module.exports = __webpack_public_path__ + "static/media/PC-paste.33bc65fb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/PC-paste.svg
// module id = 87
// module chunks = 0